import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';

export interface PrivacyRequest {
  id?: string;
  userId: string;
  userName: string;
  userEmail: string;
  requestType: 'delete_account' | 'export_data';
  reason?: string;
  status: 'pending' | 'processing' | 'completed' | 'rejected';
  createdAt: Date;
  processedAt?: Date;
  adminNotes?: string;
}

export const createPrivacyRequest = async (
  userId: string | null,
  userName: string,
  userEmail: string,
  requestType: 'delete_account' | 'export_data',
  reason?: string
): Promise<string> => {
  try {
    const requestsRef = collection(db, 'privacyRequests');

    const newRequest = {
      userId: userId || 'unauthenticated',
      userName,
      userEmail,
      requestType,
      reason: reason || '',
      status: 'pending',
      createdAt: serverTimestamp(),
    };

    const docRef = await addDoc(requestsRef, newRequest);
    return docRef.id;
  } catch (error) {
    console.error('Erro ao criar solicitação de privacidade:', error);
    throw error;
  }
};

export const getAllPrivacyRequests = async (): Promise<PrivacyRequest[]> => {
  try {
    const requestsRef = collection(db, 'privacyRequests');
    const q = query(requestsRef, orderBy('createdAt', 'desc'));

    const querySnapshot = await getDocs(q);
    const requests: PrivacyRequest[] = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      requests.push({
        id: doc.id,
        userId: data.userId,
        userName: data.userName,
        userEmail: data.userEmail,
        requestType: data.requestType,
        reason: data.reason,
        status: data.status,
        createdAt: (data.createdAt as Timestamp)?.toDate(),
        processedAt: data.processedAt ? (data.processedAt as Timestamp).toDate() : undefined,
        adminNotes: data.adminNotes,
      });
    });

    return requests;
  } catch (error) {
    console.error('Erro ao buscar solicitações de privacidade:', error);
    throw error;
  }
};

export const updatePrivacyRequestStatus = async (
  requestId: string,
  status: 'pending' | 'processing' | 'completed' | 'rejected',
  adminNotes?: string
): Promise<void> => {
  try {
    const requestRef = doc(db, 'privacyRequests', requestId);
    const updates: any = {
      status,
    };

    if (status === 'completed' || status === 'rejected') {
      updates.processedAt = serverTimestamp();
    }

    if (adminNotes) {
      updates.adminNotes = adminNotes;
    }

    await updateDoc(requestRef, updates);
  } catch (error) {
    console.error('Erro ao atualizar status da solicitação:', error);
    throw error;
  }
};
